const { itemFetcherToArrayGetter, genericGetter } = require("./utilities")
const { gql } = require("@apollo/client")

const DataLoader = require("dataloader")

function batchPropGetter(obj) {
  return async function (keys) {
    const response = await obj.client.query({
      query: gql`
            {
                user${
                  obj._id || obj._email
                    ? obj._email
                      ? '(email: "' + obj._email + '")'
                      : '(id: "' + obj._id + '")'
                    : ""
                }{
                    id
                    ${keys.join("\n")}
                }
            }
        `,
    })

    const fetchedValues = keys.map((key) => response.data.user[key])

    return fetchedValues
  }
}

class User {
  constructor(client, idEmailObj) {
    this.client = client
    this._id =
      typeof idEmailObj === "string"
        ? idEmailObj
        : typeof idEmailObj === "object" && idEmailObj.id
    this._email = typeof idEmailObj === "object" && idEmailObj.email
    this.propLoader = new DataLoader(batchPropGetter(this))
  }

  static fields() {
    return [
      "id",
      "email",
      "pendingShareCount",
      "pendingShares",
      "pendingTransferCount",
      "pendingTransfers",
      "environmentCount",
      "environments",
      "developerThingCount",
      "developerThings",
      "notificationCount",
      "accessTokenCount",
      "accessTokens",
      "quietMode",
      "name",
      "profileIconColor",
      "emailIsVerified",
      "settings",
      "lengthAndMass",
      "temperature",
      "timeFormat",
      "dateFormat",
      "language",
      "passwordChangeEmail",
      "sharesEmail",
      "accessTokenCreatedEmail",
      "totpEnabled",
    ]
  }

  get id() {
    return this._id || this.propLoader.load("id")
  }

  get email() {
    return this._email || this.propLoader.load("email")
  }

  get pendingShareCount() {
    return this.propLoader.load("pendingShareCount")
  }

  get pendingShares() {
    const { getPendingShare } = require("./pendingShare")
    return itemFetcherToArrayGetter(getPendingShare, this.client)
  }

  get pendingTransferCount() {
    return this.propLoader.load("pendingTransferCount")
  }

  get pendingTransfers() {
    const { getPendingTransfer } = require("./pendingTransfer")
    return itemFetcherToArrayGetter(getPendingTransfer, this.client)
  }

  get environmentCount() {
    return this.propLoader.load("environmentCount")
  }

  environments(options) {
    const { getEnvironment } = require("./environment")

    const sortBy = options ? options.sortBy : undefined
    const sortDirection = options ? options.sortDirection : undefined
    const filter = options ? options.filter : undefined

    return itemFetcherToArrayGetter(
      getEnvironment(sortBy, sortDirection, filter),
      this.client
    )
  }

  get developerThingCount() {
    return this.propLoader.load("developerThingCount")
  }

  developerThings(options) {
    const { getDeveloperThing } = require("./thing")

    const sortBy = options ? options.sortBy : undefined
    const sortDirection = options ? options.sortDirection : undefined
    const filter = options ? options.filter : undefined

    return itemFetcherToArrayGetter(
      getDeveloperThing(sortBy, sortDirection, filter),
      this.client
    )
  }

  get notificationCount() {
    return this.propLoader.load("notificationCount")
  }

  get accessTokenCount() {
    return this.propLoader.load("accessTokenCount")
  }

  get accessTokens() {
    const { getAccessToken } = require("./accessToken")
    return itemFetcherToArrayGetter(getAccessToken, this.client)
  }

  get quietMode() {
    return this.propLoader.load("quietMode")
  }

  get name() {
    return this.propLoader.load("name")
  }

  get profileIconColor() {
    return this.propLoader.load("profileIconColor")
  }

  get emailIsVerified() {
    return this.propLoader.load("emailIsVerified")
  }

  get lengthAndMass() {
    return this.propLoader.load("lengthAndMass")
  }

  get temperature() {
    return this.propLoader.load("temperature")
  }

  get timeFormat() {
    return this.propLoader.load("timeFormat")
  }

  get dateFormat() {
    return this.propLoader.load("dateFormat")
  }

  get language() {
    return this.propLoader.load("language")
  }

  get totpEnabled() {
    return this.propLoader.load("totpEnabled")
  }

  get passwordChangeEmail() {
    return this.propLoader.load("passwordChangeEmail")
  }

  get sharesEmail() {
    return this.propLoader.load("sharesEmail")
  }

  get accessTokenCreatedEmail() {
    return this.propLoader.load("accessTokenCreatedEmail")
  }
}

const getAdmin = (environmentId) =>
  genericGetter(
    async (index) =>
      gql(`
{
    environment(id:"${await environmentId}") {
        id
        admins(offset:${index},limit:1){
            id
        }
    }
}
`),
    "environment.admins",
    User
  )

const getEditor = (environmentId) =>
  genericGetter(
    async (index) =>
      gql(`
{
    environment(id:"${await environmentId}") {
        id
        editors(offset:${index},limit:1){
            id
        }
    }
}
`),
    "environment.editors",
    User
  )

const getSpectator = (environmentId) =>
  genericGetter(
    async (index) =>
      gql(`
{
    environment(id:"${await environmentId}") {
        id
        spectators(offset:${index},limit:1){
            id
        }
    }
}
`),
    "environment.spectators",
    User
  )

module.exports = { User, getAdmin, getEditor, getSpectator }
